export default __webpack_public_path__ + "static/media/logo_rce.23781ae1.png";